$(document).on('submit', '.ais-Hits-item form[action^="/cart/add"]', function(evt){
    evt.preventDefault();

    var form = $(this).closest('form');

    var href = form.find('a').attr('href');
    var json_href = (href) + '.json';

    var sample_id = ''
    $.getJSON("https://www.bertandmay.com" + json_href, function( data ) {
      var product_variants = data['product']['variants'];

      for ( i=0; i<product_variants.length; i++ ) {
        var variant = product_variants[i];
        if ( variant['title'] == 'Sample'){
          sample_id = variant['id'];
        }
        
      }
      
    }).done(function(){
      form.find('input[name="id"]').attr('value', sample_id);
      var sample_id_input = form.find('input[name="id"]').attr('value');
  
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: { id: sample_id_input, quantity: 1 },
        success: function () {
          window.location = '/cart';
        },
      });
    });  
});

function calculate_b2b_price(){
  $('.b2b_pricing .ais-Hits-list .ais-Hits-item').each(function(){
    var parent = $(this)
    var form = $(this).find('form');
    var href = form.find('a').attr('href');
    var json_href = (href) + '.json';
    var base_price = '';
    var text_decoration = '';

    if (typeof parent.find('product-item').data('product') == 'string') {
          let find_start = parent.find('product-item').data('product').search(/<.+\"/i);
          let find_end = parent.find('product-item').data('product').substring(find_start).search(/\">/i);
          let find = parent.find('product-item').data('product').substring(find_start, find_start + find_end + 1);
          let replace_with = find.replaceAll("\"", "\\\"");
          let new_data = parent.find('product-item').data('product').replaceAll(find, replace_with);
          try {
            new_data = JSON.parse(new_data);
            parent.find('product-item').data('product', new_data);
          } catch (error) {
            console.log(error);
            console.log(new_data);
          } 
        }
    
    $.getJSON("https://www.bertandmay.com" + json_href, function( data ) {
      
      var product_variants = data['product']['variants']; 
      var variant_index = 0;
      if (
        !parent.find('product-item').data('product').inventory_available && 
        typeof product_variants[1] != 'undefined' && 
        product_variants[1]['title'] == "MTO-Box"
      ) {
        variant_index = 1;
      }

      var variant = product_variants[variant_index];
      base_price = variant['price'] ;
      if ( data['product']['title'].indexOf("Rug") >= 0){
         text_decoration = 'Rug';
      } else if( data['product']['title'].indexOf("SQM") >= 0 ){
         text_decoration = 'SQM';
      } else {
        text_decoration = variant['title'] ;
      }
    }).done(function(){
        var discount_amount = parent.find('.b2b-price').data('dv');
        var discount_percentage = 100 - discount_amount
        var price_inc_discount = ((base_price / discount_percentage) * 100).toFixed(2)
      
        if (text_decoration == 'Box' || text_decoration == 'MTO-Box') {
          
          if (
            typeof parent.find('product-item').data('product') != 'undefined' &&
            typeof parent.find('product-item').data('product').meta != 'undefined' &&
            typeof parent.find('product-item').data('product').meta.product != 'undefined' &&
            typeof parent.find('product-item').data('product').meta.product['product-tilesperm2'] != 'undefined'
          ) {
            var tiles_per_m2 = parent.find('product-item').data('product').meta.product['product-tilesperm2'];
          } else {
            var tiles_per_m2 = false;
          }

          if (
            typeof parent.find('product-item').data('product') != 'undefined' &&
            typeof parent.find('product-item').data('product').meta != 'undefined' &&
            typeof parent.find('product-item').data('product').meta.custom != 'undefined' &&
            typeof parent.find('product-item').data('product').meta.custom['tiles_per_box_'] != 'undefined'
            ) {
            var tiles_per_box = parent.find('product-item').data('product').meta.custom['tiles_per_box_'];
          } else {
            var tiles_per_box = false
          }
          var multiplier = tiles_per_m2 / tiles_per_box;
          multiplier = Math.round(multiplier * 1000000) / 1000000;
          
          if (tiles_per_m2 && tiles_per_box) {
            base_price = (base_price / tiles_per_box) * tiles_per_m2;
            base_price = Math.round(base_price * 100) / 100;
            base_price = base_price.toFixed(2);
            
            price_inc_discount = price_inc_discount * multiplier;

            price_inc_discount = Math.round(price_inc_discount * 100) / 100;

            price_inc_discount = price_inc_discount.toFixed(2);

            text_decoration = 'M2';
          }
        } else {
          if (
            typeof parent.find('product-item').data('product') != 'undefined' &&
            typeof parent.find('product-item').data('product').meta != 'undefined' &&
            typeof parent.find('product-item').data('product').meta.product != 'undefined' &&
            typeof parent.find('product-item').data('product').meta.product['product-tilesperm2'] != 'undefined'
          ) {
            var tiles_per_m2 = parent.find('product-item').data('product').meta.product['product-tilesperm2'];

            base_price = base_price * tiles_per_m2;
            base_price = Math.round(base_price * 100) / 100;
            base_price = base_price.toFixed(2);
            price_inc_discount = price_inc_discount * tiles_per_m2;
            price_inc_discount = Math.round(price_inc_discount * 100) / 100;
            price_inc_discount = price_inc_discount.toFixed(2);
            text_decoration = 'M2';
            
          } else if (text_decoration.indexOf('Default') !== false) {
            if (
              typeof parent.find('product-item').data('product') != 'undefined' &&
              typeof parent.find('product-item').data('product').meta != 'undefined' &&
              typeof parent.find('product-item').data('product').meta.details != 'undefined' &&
              typeof parent.find('product-item').data('product').meta.details['custom_unit'] != 'undefined'
            ) {
                text_decoration = parent.find('product-item').data('product').meta.details['custom_unit'];
                text_decoration = text_decoration.replace(/per /i, '');
            } else {
              text_decoration = 'Tile';
            }
          }
        }

        if (text_decoration != '') {
          text_decoration = ' / Per ' + text_decoration;
        }
      
        parent.find('.b2b-price').find('.b2b').html('<p>£ ' + base_price + text_decoration + '</p>');
        parent.find('.b2b-price').find('.retail').html('<p>Retail: £ ' + price_inc_discount + '</p>'); 
    }).fail(function(){
        parent.hide();
    });
    
  }); 
}

$(function(){
  $(window).on('load', function(){ 
    calculate_b2b_price()

    $('.ais-hits-container .ais-Hits-list .ais-Hits-item').each(function(){
      var parent = $(this);
      var child = $(this).children();

      var badge = child.data('badge');
      var badge_location = parent.find('.product-badge');

      if (badge.length > 0){
        badge_location.html(badge);
      } else {
        badge_location.hide();
      }
      
    });
    
  });
});

$(function(){
  $(window).on('algolia-rendered', function(){ 
    calculate_b2b_price();
  });
});

$(document).on('click', '.ais-Pagination-list li a', function(evt){
  var href = $(this).attr('href');
  window.location = href;
});

